module.exports = __webpack_public_path__ + "static/media/grad9.c943468a.jpg";